//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('libraryEmptyState', {
    template: require('@legacy-components/content/library-empty-state.html'),
  });
})();
